import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useLazyQuery } from '@apollo/client'
// import useTranslation from 'next-translate/useTranslation'

import { GET_QUIZ_BY_ID_FRONT } from '@graphql/quiz/quiz.query'
import useQuiz from '@shared/hooks/useQuiz'

const PollStyle = dynamic(() => import('@shared/components/multiPoll/pollStyle'))
const StartQuiz = dynamic(() => import('@shared/components/multiQuiz/startQuiz'))
const EndQuiz = dynamic(() => import('@shared/components/multiQuiz/endQuiz'))
const VideoQuiz = dynamic(() => import('@shared/components/multiQuiz/videoQuiz'))
const SimpleQuiz = dynamic(() => import('@shared/components/multiQuiz/simpleQuiz'))
const MediaQuiz = dynamic(() => import('@shared/components/multiQuiz/mediaQuiz'))
// const CtToolTip = dynamic(() => import('@shared/components/ctToolTip'))
// const ResultQuiz = dynamic(() => import('@shared/components/multiQuiz/resultQuiz'))

const MultiQuiz = ({ id, data = {}, className }) => {
  // const { t } = useTranslation()
  const [ind, setInd] = useState(data?.aQuestions?.length > 0 ? { i: '-1' } : { i: undefined })
  const quizData = useRef(mapApiData(data))
  const currentQuiz = quizData.current?.aQuestions?.[ind?.i]
  const { getAllAnswer } = useQuiz({})
  const allAnswer = getAllAnswer(quizData.current?._id)

  const [getQuizById] = useLazyQuery(GET_QUIZ_BY_ID_FRONT)

  async function getQuizData(_id) {
    const sFingerPrint = localStorage.getItem('UPId')
    try {
      const { data } = await getQuizById({ variables: { input: { _id: _id || id, sFingerPrint } }, fetchPolicy: 'network-only' })
      if (data?.getQuizByIdFront) {
        quizData.current = mapApiData(data?.getQuizByIdFront ? { ...data?.getQuizByIdFront } : {})
        setInd(quizData.current?.aQuestions?.length > 0 ? { i: '-1' } : { i: undefined })
        // setInd({ i: 3 })
      }
    } catch (error) {
      console.log(error)
    }
  }

  function mapApiData(d) {
    d.aQuestions = d?.aQuestions?.map((e) => {
      return {
        ...e,
        quizId: d?._id,
        aQuestions: e?.aQuestions?.map((q) => {
          return {
            ...q,
            quizId: d?._id
          }
        })
      }
    })
    return d
  }

  function getRenderComponent() {
    const addClass = quizData?.current?.aQuestions?.length > 1
    if (ind?.i === '-1') return <StartQuiz data={quizData.current} handleStart={setInd} />
    else if (ind?.i === '+1') return <EndQuiz data={quizData.current} />
    else if (currentQuiz?.eType === 'vq') {
      return <VideoQuiz data={currentQuiz} />
    } else if (currentQuiz?.eType === 'sq' || currentQuiz?.eType === 'mq') {
      return <SimpleQuiz data={currentQuiz} className={addClass ? 'pt-4' : ''} />
    } else if (currentQuiz?.eType === 'ma') {
      return <MediaQuiz data={currentQuiz} className={addClass ? 'pt-4' : ''} />
    } else return null
  }

  function handleNextSlide(currentSlide, i) {
    // console.log(allAnswer?.[currentSlide?._id])
    if (currentSlide?.eType === 'vq') {
      const check = currentSlide?.aQuestions?.every((question) => allAnswer?.[question._id])
      check && setInd({ i: i })
    } else if (allAnswer?.[currentSlide?._id]) setInd({ i: i })
  }

  useEffect(() => {
    id && getQuizData(id)
  }, [id])

  useEffect(() => {
    function handleNext() {
      setTimeout(() => {
        setInd((j) => {
          if (j?.i + 1 < quizData?.current?.aQuestions?.length) {
            return { i: j?.i + 1 }
          } else {
            return { i: '+1' }
          }
        })
      }, 1500)
    }
    window.addEventListener(quizData.current?._id, handleNext)
    return () => window.removeEventListener(quizData.current?._id, handleNext)
  }, [quizData.current])

  if (quizData?.current?._id) {
    return (
      <div className={`position-relative br-sm overflow-hidden mx-auto ${className || ''}`} style={{ maxWidth: '375px' }}>
        {ind?.i !== '-1' && ind?.i !== '+1' && quizData.current?.aQuestions?.length > 1 && (
          <PollStyle>
            {(pollStyle) => (
              <>
                <div className={`${pollStyle.pollDot} w-100 d-flex px-1 position-absolute mx-auto mw-100 start-50 translate-middle-x`}>
                  {quizData.current?.aQuestions?.map((p, i) => (
                    <div
                      key={p?._id}
                      className={`${pollStyle.dot} ${i === ind?.i ? pollStyle.active : ''} ${
                        i === ind?.i + 1 ? 'c-pointer' : ''
                      } flex-grow-1 rounded-pill mx-1 position-relative`}
                      onClick={() => {
                        if (i === ind?.i + 1) handleNextSlide(quizData.current?.aQuestions?.[ind?.i], ind?.i + 1) // for Next
                        else if (i < ind?.i) handleNextSlide(quizData.current?.aQuestions?.[i], i) // For previous
                      }}
                    />
                  ))}
                </div>
                {/* {ind?.i > 0 && (
                  <CtToolTip tooltip={t('common:Previous')}>
                    <button
                      className={`${pollStyle.arrow} ${pollStyle.prev} light-bg position-absolute top-50 translate-middle-y start-0`}
                      onClick={() => handleNextSlide(quizData.current?.aQuestions?.[ind?.i], ind?.i - 1)}
                    >
                      {t('common:Prev)}
                    </button>
                  </CtToolTip>
                )}
                {ind?.i < quizData.current?.aQuestions?.length - 1 && (
                  <CtToolTip tooltip={t('common:Next')}>
                    <div
                      className={`${pollStyle.arrow} ${pollStyle.next}  light-bg position-absolute top-50 translate-middle-y end-0`}
                      onClick={() => handleNextSlide(quizData.current?.aQuestions?.[ind?.i], ind?.i + 1)}
                    >
                      {t('common:Next)}
                    </div>
                  </CtToolTip>
                )} */}
              </>
            )}
          </PollStyle>
        )}
        {getRenderComponent()}
        {/* <ResultQuiz /> */}
      </div>
    )
  } else return null
}
MultiQuiz.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  className: PropTypes.string
}
export default MultiQuiz
